"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorResult = exports.SuccessResult = void 0;
var web_ui_framework_1 = require("@gruposantander/web-ui-framework");
Object.defineProperty(exports, "SuccessResult", { enumerable: true, get: function () { return web_ui_framework_1.SuccessResult; } });
Object.defineProperty(exports, "ErrorResult", { enumerable: true, get: function () { return web_ui_framework_1.ErrorResult; } });
//# sourceMappingURL=index.js.map